import React from "react";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import Item from "@mui/material/MenuItem";
import List from "@mui/material/MenuList";
import { getClassName } from "@sscs/utils";
import styles from "./menu.module.scss";
/**
 * A named group heading inside a popup listbox or menu: the `Section.Title` legend look, but WITHOUT
 * a heading tag — a group header in a listbox/menu is a presentational row, not an `<h*>`. Untitled
 * groups keep `Menu.Divider`.
 */
const GroupTitle = ({ className, children, }) => (React.createElement("li", { role: "presentation", className: getClassName(styles["group-title"], className) },
    React.createElement("span", { className: styles["group-title-text"] }, children),
    React.createElement("span", { className: styles.rule, "aria-hidden": true })));
export default {
    Menu,
    Item,
    List,
    Divider,
    GroupTitle,
};
//# sourceMappingURL=Menu.js.map